import React from "react";
import { useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";

const PagoFallido = () => {
  const [params] = useSearchParams();
  const tipo = params.get("tipo");
  const id   = params.get("id");

  const handleVolver = () => {
    if (tipo && id) {
      window.location.href = `/?tipo=${encodeURIComponent(tipo)}&id=${encodeURIComponent(id)}`;
    } else {
      window.location.href = "/";
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-rose-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-10 max-w-md w-full text-center border border-red-100">
        <div className="flex justify-center mb-6">
          <XCircle className="w-20 h-20 text-red-500" />
        </div>
        <h1 className="text-3xl font-bold text-red-700 mb-2">Pago no completado</h1>
        <p className="text-gray-500 mb-8">
          No se pudo procesar el pago. No se realizó ningún cobro. Podés intentarlo nuevamente.
        </p>
        <button
          onClick={handleVolver}
          className="block w-full bg-gradient-to-r from-blue-600 to-sky-500 text-white font-semibold py-3 rounded-xl hover:from-blue-700 hover:to-sky-600 transition-all"
        >
          Volver a mi consulta
        </button>
      </div>
    </div>
  );
};

export default PagoFallido;
